import { useEffect } from 'react';
import { connect } from 'react-redux';
import { getViewInfo } from 'axp-data-manager-utils';
import { useDDL } from '@americanexpress/react-ddl';

export const UpdateViewDdl = ({ updateViewData, locale }) => {
  const { updateDDL } = useDDL();
  useEffect(() => {
    if (updateViewData) {
      updateDDL({
        name: 'view',
        value: {
          ...getViewInfo(),
          ...{
            country: locale.split('-')[1],
            language: locale.split('-')[0],
            locale,
            ...updateViewData,
          },
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- locale and updateDDL are stable references
  }, [updateViewData]);
  return null;
};

export const mapStateToProps = (state) => ({
  updateViewData: state.getIn(['modules', 'axp-prospect-root', 'updateViewData']),
});

const UpdateViewDDL = UpdateViewDdl;
export default connect(mapStateToProps)(UpdateViewDDL);
